import { Offcanvas, Row } from 'react-bootstrap';
import React from 'react';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { FormProvider, useForm } from 'react-hook-form';
import { AddEntityDrawerProps } from './EntityListProps';
import { useCreateIncidentStrategy } from './hooks/incidentStrategyHooks';
import DrawerWrapper, { DrawerFooter } from './DrawerWrapper';
import FormTextField from './formFields/FormTextField';
import FormTextAreaField from './formFields/FormTextAreaField';
import { useCreateStrategy } from './hooks/strategyHooks';
import { INCIDENT } from './ICSConstants';
import { StrategyBase } from '../../types/iapBaseTypes';

type FormFields = StrategyBase;

const StrategyAddDrawer: React.FC<AddEntityDrawerProps> = ({ toggle, scope }) => {
  const form = useForm<FormFields>({
    mode: 'onChange',
  });
  const {
    handleSubmit,
    watch,
  } = form;

  const watchedName = watch('name');

  const incidentStrategyMutation = useCreateIncidentStrategy();
  const strategyMutation = useCreateStrategy();
  const mutation = scope === INCIDENT ? incidentStrategyMutation : strategyMutation;

  const onNewStrategyDataSubmit = async (formData: FormFields) => {
    const payload = {
      name: formData.name,
      description: formData.description,
      archived: false,
    };
    await mutation.mutateAsync(payload);
    toggle();
  };

  return (
    <DrawerWrapper toggle={toggle} title="Add Strategy">
      <FormProvider {...form}>
        <form
          onSubmit={handleSubmit(onNewStrategyDataSubmit)}
          className="d-flex flex-column justify-content-between flex-grow-1"
        >
          <Offcanvas.Body>
            <Row>
              <FormTextField
                title="Name"
                fieldName="name"
                rules={{
                  required: { value: true, message: 'This field is required' },
                  maxLength: {
                    value: 300,
                    message: 'The maximum length is 300 characters',
                  },
                }}
                variant="half"
              />
            </Row>
            <Row>
              <FormTextAreaField
                title="Description"
                fieldName="description"
                rules={{
                  maxLength: {
                    value: 300,
                    message: 'The maximum length is 300 characters',
                  },
                }}
                variant="full"
              />
            </Row>
          </Offcanvas.Body>
          <DrawerFooter>
            <div className="button-group">
              <StylishNewButton
                className="button--secondary button--reverse"
                type="button"
                onClick={toggle}
              >
                Close
              </StylishNewButton>
              <StylishNewButton
                className="button--primary"
                type="submit"
                disabled={!watchedName || mutation.isPending}
              >
                Save
              </StylishNewButton>
            </div>
          </DrawerFooter>
        </form>
      </FormProvider>
    </DrawerWrapper>
  );
};

export default StrategyAddDrawer;